import { Modal, ModalId } from "../../../../../features/ui"
import styles from './confirmBaseChangeModal.module.css'

type Props = {
    onConfirm: () => void
    onCancel: () => void
}

export const ConfirmBaseChangeModal = (props: Props) => {
    const { onConfirm, onCancel } = props

    return (
        <Modal
            modalId={ModalId.CONFIRM_BASE_CHANGE}
            title="¿Cambiar Lista Base?"
            submitLabel="Cambiar y Reemplazar"
            cancelLabel="Cancelar"
            widthSize="s"
            onSubmit={onConfirm}
            onCancel={onCancel}
        >
            <div className={styles.container}>
                <p>
                    Cambiar la lista base <strong>reemplazará los Productos Excluidos</strong> por los de la lista base seleccionada.
                </p>
                <p className={styles.note}>
                    <strong>Nota:</strong> Los Ajustes por Producto se mantendrán, pero sus precios finales se recalcularán sobre la nueva base.
                </p>
            </div>
        </Modal>
    )
}
